module.exports = __webpack_public_path__ + "img/04—02—Phonebook > IB2.9fd0190d.jpg";